import { IMaintenanceWorkOrdersPageState } from "interfaces/MaintenanceWorkOrdersPageState";
import { initialSliderFilterValues } from "pages/WorkOrdersPage/MaintenanceWorkOrdersPage/WorkOrdersFiltersDialog/filterOptions";
import {
  CLEAR_ASSIGNED_FILTERS,
  CLEAR_CANCELED_FILTERS,
  CLEAR_CLOSED_FILTERS,
  CLEAR_COMPLETE_FILTERS,
  CLEAR_OPEN_FILTERS,
  IMaintenanceWorkOrdersPagesAC,
  SET_ASSIGNED_FILTERS,
  SET_CANCELED_FILTERS,
  SET_CLOSED_FILTERS,
  SET_COMPLETE_FILTERS,
  SET_OPEN_FILTERS
} from "store/actions/maintenanceWorkOrdersPage";

const initialState: IMaintenanceWorkOrdersPageState = {
  openFilters: {
    openDate: 0,
    orderTypes: null,
    reporters: [],
    timeOpen: initialSliderFilterValues
  },
  assignedFilters: {
    assignedDate: 0,
    assignedTo: null,
    orderTypes: null,
    reporters: [],
    timeAssigned: initialSliderFilterValues
  },
  completeFilters: {
    assignedDate: 0,
    assignedTo: null,
    completedDate: 0,
    orderTypes: null,
    timeAssigned: initialSliderFilterValues
  },
  closedFilters: {
    closedDate: 0,
    assignedTo: null,
    orderTypes: null,
    reporters: [],
    timeOpen: initialSliderFilterValues,
    timeAssigned: initialSliderFilterValues
  },
  canceledFilters: {
    openDate: 0,
    assignedTo: null,
    canceledDate: 0,
    orderTypes: null,
    reporters: [],
    timeAssigned: initialSliderFilterValues
  }
};

export default (
  state: IMaintenanceWorkOrdersPageState = initialState,
  action: IMaintenanceWorkOrdersPagesAC
): IMaintenanceWorkOrdersPageState => {
  switch (action.type) {
    case SET_OPEN_FILTERS:
      return {
        ...state,
        openFilters: action.openFilters
      };
    case CLEAR_OPEN_FILTERS:
      return {
        ...state,
        openFilters: initialState.openFilters
      };
    case SET_ASSIGNED_FILTERS:
      return {
        ...state,
        assignedFilters: action.assignedFilters
      };
    case CLEAR_ASSIGNED_FILTERS:
      return {
        ...state,
        assignedFilters: initialState.assignedFilters
      };
    case SET_COMPLETE_FILTERS:
      return {
        ...state,
        completeFilters: action.completeFilters
      };
    case CLEAR_COMPLETE_FILTERS:
      return {
        ...state,
        completeFilters: initialState.completeFilters
      };
    case SET_CLOSED_FILTERS:
      return {
        ...state,
        closedFilters: action.closedFilters
      };
    case CLEAR_CLOSED_FILTERS:
      return {
        ...state,
        closedFilters: initialState.closedFilters
      };
    case SET_CANCELED_FILTERS:
      return {
        ...state,
        canceledFilters: action.canceledFilters
      };
    case CLEAR_CANCELED_FILTERS:
      return {
        ...state,
        canceledFilters: initialState.canceledFilters
      };
    default:
      return state;
  }
};
